const activeClass = "checkmark-active";
const visibilityHiddenClass = "visibility-hidden";
let siteId = "";
let currentCulture = "";
let omraadeId: number = 0;
let kundetype: string = "";

$(document).ready(() => {
    initSlider();
    currentCulture = $('body').data('currentCulture');
    siteId = $('body').data('siteId');

    $('.checkmark-card[data-kundetype]').off().on('click', function () {
        if ($(this).hasClass(activeClass)) {
            return;
        }

        $('.checkmark-card[data-kundetype]').removeClass(activeClass);
        $(this).addClass(activeClass);
        kundetype = $(this).data("kundetype");

        if ($('.slides').hasClass(visibilityHiddenClass)) {
            $('.slides').removeClass(visibilityHiddenClass).hide().fadeIn('fast');
        }

        resetAreaSlider();
        scrollToElement('#step2');
    });

    $('.checkmark-area').on('click', function () {
        if ($(this).hasClass(activeClass)) {
            return;
        }

        hideLoader();
        moveSlickPosition(+$(this).index());
        omraadeId = $(this).data("omraadeId");

        $('.checkmark-area').removeClass(activeClass);
        $(this).addClass(activeClass);

        showLoader();
        getProdukter(omraadeId, kundetype);
    });
});

const hideLoader = () => {
    $('#results-container .product-results').removeClass("hide").addClass(visibilityHiddenClass);
    $('#results').addClass("hide");
}

const showLoader = () => {
    $('.spinner').show();
    $('#results-container .product-results').removeClass(visibilityHiddenClass).hide().fadeIn('fast');
}

const resetAreaSlider = () => {
    omraadeId = 0;
    $('.checkmark-area').removeClass(activeClass);
    moveSlickPosition(0);
    $('#results-container').removeClass("hide");
    hideLoader();
}

const moveSlickPosition = (index: number) => {
    ($('.slider') as any).slick('slickGoTo', index);
}

const unSlick = () => {
    ($('.slider') as any).slick('unslick');
}

const showProdukter = (html: string) => {
    $('#results .product-result-grid').html(html);
    $('.spinner').fadeOut('fast', function() {
        $('#results').removeClass("hide").hide().fadeIn('fast');
    });
    scrollToElement('.product-results');
}

const getProdukter = (omraadeId: number, kundetype: string) => {
    $.ajax({
        url: `/umbraco/api/produkter/getprodukter?siteId=${siteId}&currentCulture=${currentCulture}&omraadeId=${omraadeId}&kundetype=${kundetype}`,
        success: function (result) {
            var newHtml = "";
            changeOverskrift(result.Overskrift);

            for (var produkt of result.Produkter) {
                newHtml += buildProduktHtml(produkt.Url,
                    produkt.Navn,
                    produkt.Tekst,
                    produkt.AntalPAnlaeg,
                    produkt.PrisFraTekst,
                    produkt.IkonUrl);
            }
            setTimeout(() => {
                showProdukter(newHtml);
            }, 500);
        }
    });
}

const changeOverskrift = (nyOverskrift: string) => {
    $('.produkter-results-headline').html(nyOverskrift);
}

const initSlider = () => {
    ($('.slider') as any).slick({
        dots: true,
        infinite: false,
        arrows: true,
        centerPadding: '0',
        slidesToShow: 1,
        initialSlide: 0,
        width: '1200px',
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    arrows: true,
                    draggable: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    draggable: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    draggable: false,
                    slidesToScroll: 3,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    draggable: true,
                    slidesToScroll: 2,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    draggable: false,
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            }
        ]
    });
}

const buildProduktHtml = (url: string, navn: string, tekst: string, antalPAnlaegString: string, prisFraTekst: string, iconUrl: string) => {
    return `
                    <a class="product-card" href="${url}">
                        <h3><i><img src="${iconUrl}" /></i> ${navn}</h3>

                        <div class="content">
                            <p class="description">
                                ${tekst}
                            </p>

                            <p class="anlaeg">
                                <b>${antalPAnlaegString}</b>
                            </p>
                            <p class="price">
                                <b>${prisFraTekst}</b>
                            </p>
                        </div>

                        <i>
                            <svg class="embla-icon" aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <use xlink:href="/dist/icons/sprite.symbol.svg#forward"></use>
                            </svg>
                        </i>

                    </a>
`;
}

const scrollToElement = (selector: string) => {
    if ($(window).width() < 768) {
        $([document.documentElement, document.body]).animate({
                scrollTop: ($(selector).offset().top - 82)
            },
            350);
    }
}


// WEBPACK FOOTER //
// ./Content/scripts/pages/produkter.ts